/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ---------------------------------------------------------------
   Fourth-level product flyout: viewport-overflow flip.
   Runs on every mega-menu with product flyouts and only toggles
   the --flyout-left modifier when the popup would actually clip
   the right edge of the viewport.  Re-runs on resize.
   --------------------------------------------------------------- */
(function () {
  var items = document.querySelectorAll('.mega-menu__item--has-product-flyout');
  if (!items.length) return;
  var FLYOUT_MIN_WIDTH = 260; // matches CSS min-width on .mega-menu__product-flyout

  function updateFlip(item) {
    var wrap = item.querySelector('.mega-menu__link-wrap');
    if (!wrap) return;
    var rect = wrap.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;
    var overflows = (rect.right + FLYOUT_MIN_WIDTH) > window.innerWidth;
    wrap.classList.toggle('mega-menu__link-wrap--flyout-left', overflows);
  }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () { updateFlip(item); });
    item.addEventListener('mouseleave', function () {
      var wrap = item.querySelector('.mega-menu__link-wrap');
      if (wrap) wrap.classList.remove('mega-menu__link-wrap--flyout-left');
    });
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { items.forEach(updateFlip); }, 100);
  });
})();
